<template>
  <div>
    <SnapshotEdit ref="SnapshotEdit" v-on:editComplete="getSnapshotData(snapshot.page)"></SnapshotEdit>
    <VolumeEdit ref="VolumeEdit" v-on:editComplete="$router.push({ name: 'volumes' })"></VolumeEdit>
    <Card shadow>
      <Row v-if="showRefreshBtn">
        <div style="float: left">
          <AllTenantSwitch ref="AllTenantSwitch" v-on:callback="getSnapshotData()"></AllTenantSwitch>
        </div>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getSnapshotData(snapshot.page)">刷新</Button>
        </div>
      </Row>
      <Table
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="snapshot.data"
        :columns="snapshot.columns">
        <template slot="more_action" slot-scope="props">
          <Button @click="$refs.VolumeEdit.openModal('snapshot', props.row)" type="primary" size="small" style="margin-right: 5px">创建云硬盘</Button>
          <Dropdown transfer trigger="click" @on-click="v => {tableMoreActionTrigger(v, props.row)}">
            <Button type="dashed" size="small">
              更多操作
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem name="edit">编辑</DropdownItem>
              <DropdownItem name="delete"><span :style="{color: 'red'}">删除</span></DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ snapshot.data.length }} 条记录，总共 {{ snapshot.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="snapshot.count"
            :current="snapshot.page"
            :page-size="snapshot.size"
            @on-change="getSnapshotData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudVolumeSnapshot, deletePrivateCloudVolumeSnapshot } from '@/api/private-cloud/volume-snapshot'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import AllTenantSwitch from '@/view/private-cloud/components/allTenantSwitch'
import SnapshotEdit from './components/snapshot-edit'
import VolumeEdit from './components/volume-edit'
import moment from 'moment'

export default {
  components: {
    SnapshotEdit,
    VolumeEdit,
    AllTenantSwitch,
    moment
  },
  props: {
    volume_id: {
      type: String,
      default: ''
    },
    showRefreshBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      tableLoading: false,
      snapshot: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '租户',
            minWidth: 130,
            align: 'center',
            key: 'os-extended-snapshot-attributes:project_id',
            render: (h, params) => {
              return h('span', resourceIdTransName('projects', params.row['os-extended-snapshot-attributes:project_id']))
            }
          },
          {
            title: '快照名称',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'name'
          },
          {
            title: '描述',
            align: 'center',
            minWidth: 200,
            key: 'description',
            tooltip: true
          },
          {
            title: '大小',
            align: 'center',
            minWidth: 120,
            tooltip: true,
            key: 'size',
            render: (h, params) => {
              return h('span', params.row.size + ' GiB')
            }
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let status = params.row.status
              let color = status === 'creating' ? 'warning'
                : status === 'available' ? 'success'
                  : status === 'backing-up' ? 'warning'
                    : status === 'deleting' ? 'warning'
                      : status === 'error' ? 'error'
                        : status === 'deleted' ? 'error'
                          : status === 'unmanaging' ? 'warning'
                            : status === 'restoring' ? 'warning'
                              : status === 'error_deleting' ? 'error'
                                : 'warning'
              let text = status === 'creating' ? '创建中'
                : status === 'available' ? '可用'
                  : status === 'backing-up' ? '正在备份'
                    : status === 'deleting' ? '删除中'
                      : status === 'error' ? '错误'
                        : status === 'deleted' ? '已删除'
                          : status === 'unmanaging' ? '非管理状态'
                            : status === 'restoring' ? '正在恢复云硬盘'
                              : status === 'error_deleting' ? '删除时出错'
                                : status
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          {
            title: '云硬盘',
            align: 'center',
            minWidth: 220,
            tooltip: true,
            key: 'volume_id',
            render: (h, params) => {
              if (params.row.volume_id) {
                return h('a', {
                  on: {
                    click: () => {
                      this.$router.push({ name: 'volume_detail', params: { id: params.row.volume_id } })
                    }
                  }
                }, (resourceIdTransName('volumes', params.row.volume_id)))
              }
            }
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 200,
            key: 'created_at',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              return h('div', [
                h('div',
                  this.$refs.table.$scopedSlots.more_action({
                    row: params.row,
                    idx: params.row._index
                  })
                )
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      }
    }
  },
  mounted: function () {
    this.getSnapshotData()
  },
  methods: {
    // 获取云硬盘快照列表数据
    getSnapshotData (value = 1) {
      this.snapshot.page = value
      let params = {
        page: this.snapshot.page,
        size: this.snapshot.size
      }
      if (this.volume_id) {
        params.volume_id = this.volume_id
      } else {
        params.all_tenants = this.$refs.AllTenantSwitch.allTenants()
      }
      this.tableLoading = true
      getPrivateCloudVolumeSnapshot(params).then(res => {
        this.snapshot.data = res.data.results
        this.snapshot.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取云硬盘快照列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取云硬盘快照列表失败！服务器无响应'
          })
        }
      })
    },
    // 删除云硬盘快照
    delete (row) {
      deletePrivateCloudVolumeSnapshot(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getSnapshotData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 表格更多操作触发
    tableMoreActionTrigger (name, row) {
      switch (name) {
        case 'edit':
          this.$refs.SnapshotEdit.modifyOpenModal(row)
          break
        case 'delete':
          this.$Modal.confirm({
            title: '删除',
            content: '确定要删除云硬盘快照「' + row.name + '」吗？ 此操作将无法撤回！',
            onOk: () => {
              this.delete(row)
            }
          })
          break
      }
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
